// AJAX Filtering for Content List with Two-Column Layout
// This script handles filter changes, pagination reset, and AJAX updates

document.addEventListener('DOMContentLoaded', function () {
    const filterForm = document.getElementById('filterForm');
    const filterSelects = document.querySelectorAll('.filter-select');
    const keywordInput = document.getElementById('keyword');
    const clearButton = document.getElementById('clearFilters');
    const resultsContainer = document.getElementById('resultsContainer');
    const loadingOverlay = document.getElementById('loadingOverlay');
    const ajaxUrlElement = document.querySelector('.filtered-content-ajax');

    // Exit if required elements don't exist on the page
    if (!filterForm || !resultsContainer || !loadingOverlay || !ajaxUrlElement) {
        return;
    }

    // Get base URL and remove any pagination segments (e.g., -page-2-)
    let ajaxUrl = ajaxUrlElement.dataset.ajaxUrl;
    ajaxUrl = ajaxUrl.replace(/-page-\d+-?/gi, ''); // Remove -page-2-, -page-3-, etc.
    ajaxUrl = ajaxUrl.replace(/\/page\/\d+\/?/gi, ''); // Remove /page/2/, /page/3/, etc.
    ajaxUrl = ajaxUrl.replace(/\/$/, ''); // Remove trailing slash

    /**
     * Get form data as query string, optionally excluding pagination parameters
     * @param {boolean} excludePagination - Whether to exclude page/PageNumber/currentPage params
     * @returns {string} Query string
     */
    function getQueryString(excludePagination = false) {
        const formData = new FormData(filterForm);
        const params = new URLSearchParams();

        // Only add form values (not URL parameters)
        for (const [key, value] of formData.entries()) {
            // Skip empty values and pagination params if requested
            if (!value) continue;

            if (excludePagination && (key === 'page' || key === 'PageNumber' || key === 'currentPage')) {
                continue; // Skip pagination parameters
            }

            params.append(key, value);
        }

        return params.toString();
    }

    /**
     * Fetch and update results via AJAX
     * @param {boolean} resetPagination - Whether to reset pagination to page 1
     */
    async function fetchResults(resetPagination = false) {
        const queryString = getQueryString(resetPagination);
        const url = queryString ? `${ajaxUrl}?${queryString}` : ajaxUrl;

        // Show loading state
        loadingOverlay.classList.remove('hidden');
        resultsContainer.style.opacity = '0.5';

        try {
            const response = await fetch(url, {
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const html = await response.text();

            if (!html || html.trim().length === 0) {
                throw new Error('Empty response from server');
            }

            // Parse the HTML to extract just the results content
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const newResults = doc.querySelector('#resultsContainer');

            if (!newResults) {
                throw new Error('Results container not found in response');
            }

            resultsContainer.innerHTML = newResults.innerHTML;

            // Notify other scripts that results have been updated (e.g. injectGroupHeadings)
            resultsContainer.dispatchEvent(new CustomEvent('results:updated', { bubbles: true }));

            // Update browser URL without reload
            window.history.pushState({}, '', url);

            // Update clear button visibility after results are loaded
            updateClearButton();

        } catch (error) {
            // Only log errors in development (optional - remove for production)
            if (window.location.hostname === 'localhost') {
                console.error('Error fetching results:', error);
            }
            resultsContainer.innerHTML = '<div class="rounded-lg bg-red-50 p-8 text-center"><p class="text-red-600">Error loading results. Please try again.</p></div>';
        } finally {
            // Hide loading state
            loadingOverlay.classList.add('hidden');
            resultsContainer.style.opacity = '1';
        }
    }

    /**
     * Update the visibility of the clear filters button
     */
    function updateClearButton() {
        const hasFilters = Array.from(new FormData(filterForm).values()).some(value => value);
        if (clearButton) {
            clearButton.style.display = hasFilters ? 'block' : 'none';
        }
    }

    // Handle dropdown changes - RESET pagination to page 1
    filterSelects.forEach(select => {
        select.addEventListener('change', function () {
            // Remove any pagination inputs that might be in the form
            const pageInputs = filterForm.querySelectorAll('input[name="page"], input[name="PageNumber"], input[name="currentPage"]');
            pageInputs.forEach(input => input.remove());

            fetchResults(true); // true = reset pagination
        });
    });

    // Handle keyword search on Enter - RESET pagination to page 1
    if (keywordInput) {
        keywordInput.addEventListener('keypress', function (e) {
            if (e.key === 'Enter') {
                e.preventDefault();

                // Remove any pagination inputs that might be in the form
                const pageInputs = filterForm.querySelectorAll('input[name="page"], input[name="PageNumber"], input[name="currentPage"]');
                pageInputs.forEach(input => input.remove());

                fetchResults(true); // true = reset pagination
            }
        });
    }

    // Handle clear filters button - RESET pagination to page 1
    if (clearButton) {
        clearButton.addEventListener('click', function () {
            // Reset form fields
            filterForm.reset();

            // Clear keyword input explicitly (sometimes reset doesn't clear search inputs)
            if (keywordInput) {
                keywordInput.value = '';
            }

            // Reset all selects explicitly
            filterSelects.forEach(select => {
                select.selectedIndex = 0;
            });

            // Navigate to base URL (no query params)
            window.history.pushState({}, '', ajaxUrl);

            // Fetch results immediately
            fetchResults(true); // true = reset pagination
        });
    }

    // Handle browser back/forward buttons
    window.addEventListener('popstate', function () {
        location.reload(); // Reload page when using browser navigation
    });
});
